import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { IButtonProps } from "./IButtonProps";

@observer
export class ButtonListTiny extends React.Component<IButtonProps, {}> {

	render() {
		if (!this.props.hide) {
			return <button id={this.props.id} className={"button-list-tiny"} disabled={this.props.disabled} onClick={this.props.onClick} data-test-id={this.props.testId} data-test-name={this.props.testName} title={this.props.title ? this.props.title : this.props.title}>
				{this.props.children}
			</button>;
		}
		else {
			return null;
		}
	}
}
